<template>
  <div class="sri-page-header mt-4">
    <div class="search md-layout">
      <div class="md-layout-item md-size-30 md-small-size-100">
        <validation-field name="class name" type="autocomplete">
          <isis-autocomplete
            v-model="studentData.displayValue"
            :value.sync="studentData.value"
            :options="studentOpts"
            :refetchOptions="
              queryObj =>
                studentData.refetchOptions(studentData.displayValue, queryObj)
            "
            :fields="studentData.fields"
            :label="studentData.label"
            fetchOnOpen
          />
        </validation-field>
      </div>
      <div class="md-layout-item md-size-70 md-small-size-100">
        <md-button @click.prevent="button.action" class="md-info mr-6">
          {{ $t(button.title) }}
        </md-button>
        <div class="float-right">
          <md-button
            class="md-warning"
            @click.prevent="$emit('export-pdf')"
            v-if="showExport"
          >
            {{ $t("common.export") }}
          </md-button>
          <md-button
            v-if="isImportXlsx"
            class="md-success ml-3"
            @click.prevent="bulkActions.action"
          >
            {{ $t(bulkActions.content) }}
          </md-button>
        </div>
      </div>
      <import-xlsx-modal
        :name="importModalName"
        title="smi_sri.import_xlsx"
        :actions="importCSVModalActions"
        :formatImportedData="formatImportedData"
      >
        <template #template-desc>
          <p class="template-desc">
            {{ $t("common.download") }}
            <a
              @click="downloadTemplate"
              target="_blank"
              style="cursor: pointer"
              >{{ $t("smi_sri.xlsx_template") }}</a
            >
            {{ $t("common.see_an_example_of_the_format_required") }}
          </p>
        </template>
      </import-xlsx-modal>
    </div>
  </div>
</template>

<script>
import ImportXlsxModal from "@/components/Base/ImportXlsxModal";
import { postFileToS3, saveUploadedLink } from "@/helpers/aws-s3";
import { service_paths } from "@/constants/Services";
import { physicalPerformanceKeys } from "@/constants";
import { IndividualAssessment } from "@/constants/Permissions";
import { Message, initLoader } from "@/helpers/utils";

export default {
  name: "page-header",
  props: ["button", "data", "pathConnect", "showExport"],
  components: { ImportXlsxModal },
  data() {
    return {
      importModalName: "importXLSX",
      studentView: false,
      studentOpts: [],
      studentData: {
        label: "smi_sri.search_by_full_name",
        value: "",
        displayValue: "",
        fields: {
          text: "full_name_id",
          value: "_id"
        },
        refetchOptions: (selectedValue, queryObj) => {
          return this.getStudentOpts(selectedValue, queryObj);
        }
      },
      bulkActions: {
        content: "common.import_file",
        action: () => {
          this.$modal.show(this.importModalName);
        }
      },
      importCSVModalActions: {
        primary: {
          title: "common.upload_and_continue",
          action: this.uploadFileToS3
        }
      },
      formatImportedData: this.formatTableData
    };
  },
  computed: {
    isImportXlsx() {
      return this.$can(
        IndividualAssessment.actions.import,
        IndividualAssessment.subject
      );
    }
  },
  methods: {
    formatTableData(file) {
      return file?.map(student => ({
        [physicalPerformanceKeys.studentCode]:
          student[physicalPerformanceKeys.studentCode],
        ...student
      }));
    },
    downloadTemplate() {
      return this.$axios
        .get(this.pathConnect.templateLinks, {}, true, {}, "blob")
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.pathConnect.templateName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    getStudentOpts(value) {
      return this.$axios
        .get(
          service_paths.students + `/filter-with-role`,
          {
            limit: 10,
            search_key: value,
            fields: ["full_name", "student_code"]
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          // get memorized selected when modal is opened
          this.studentOpts = data.data;
          this.studentOpts = this.studentOpts.map(student => ({
            full_name_id: student.full_name.concat(
              " - ",
              student.student_code || ""
            ),
            ...student
          }));
        });
    },
    async uploadFileToS3(file) {
      const loader = initLoader();

      const s3FolderPath = this.pathConnect.S3ImportACTPath;

      try {
        const savedLink = await postFileToS3(s3FolderPath, file);
        await saveUploadedLink(
          savedLink,
          this.pathConnect.pathSaveUploadedLink
        );
        this.$modal.hide(this.importModalName);
        Message.success(this.$t("smi_sri.importXLSX"));
      } finally {
        loader.hide();
      }
    }
  },
  watch: {
    "studentData.value": {
      handler: function() {
        if (this.studentData.value) {
          this.$emit("studentValue", this.studentData.value);
        }
      }
    },
    "studentData.displayValue": {
      handler: function() {
        if (!this.studentData.displayValue) {
          this.$emit("studentValue", "");
        }
      }
    }
  }
};
</script>

<style lang="scss">
.sri-page-header {
  .md-autocomplete {
    label {
      z-index: auto;
    }
  }
}
</style>
